// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import MuiCssBaseline from "./MuiCssBaseline";

const overrides = {
  MuiCssBaseline,
};

export default overrides;
